import React from 'react';
import { IIcon } from '../interfaces';

function New({ onClick, type, color, className, styles }: IIcon.Props) {

    return (
        <i className={`fa${type ? type?.substr(0,1) : "s"} fa-plus-circle ${className ?? ""} text-${color}`} onClick={onClick} style={styles}> </i>
    )
}

export default New;